import React from 'react'
import { Link } from 'gatsby'

import './Layout.scss'
import shape1 from './shape-1.svg'
import shape2 from './shape-2.svg'
import shape3 from './shape-3.svg'
import epiline1 from './epiline-1.svg'
import epiline2 from './epiline-2.svg'
import epiLogo from './epi-logo.svg'
import epiIcon from './epi-icon.svg'
import Bio from './Bio'

class Layout extends React.Component {

  componentDidMount () {
    document.body.dataset.loaded = true
  }

  getCurrentYear () {
    return (new Date()).getFullYear()
  }

  render () {
    const { location, title, children, plain, root } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    const isHomepage = root
 
    return (
      <div className="Layout" data-plain={plain}>
        <div className="Layout-header">

        </div>
        <div className="Layout-content">
          {children}
        </div>
        <div className="Layout-footer">
          <footer>
            <div className="Layout-footer-content">
              {/* <div className="Layout-footer-title">
                <Link to={`/`}>{title}</Link>
              </div> */}
              <div className="Layout-footer-description">
                {!this.props.noBio && 
                  <Bio />
                }
              </div>
              <div className="Layout-footer-links">
                <a href="https://epihq.com">Epi</a>
                <span className="Layout-footer-links-separator">&middot;</span>
                <a href="https://epihq.com/legal/terms">Terms</a>
                <span className="Layout-footer-links-separator">&middot;</span>
                <a href="https://epihq.com/legal/privacy">Privacy</a>
                <span className="Layout-footer-links-separator">&middot;</span>
                <a href="https://epihq.com/legal/cookies">Cookies</a>
              </div>
              <div className="Layout-footer-copyright">
                © {this.getCurrentYear()} Epi Technologies
              </div>
            </div>
          </footer>
        </div>
        <div className="Layout-footer-shape">
            <img src={shape3} alt="" />
          </div>
        <div className="Layout-epilines">
          <div className="Layout-epiline-1 Layout-epiline-left-a">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-left-b">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-left-c">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-left-d">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-left-e">
            <img src={epiline1} alt="" />
          </div>

          <div className="Layout-epiline-1 Layout-epiline-right-a">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-right-b">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-right-c">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-right-d">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-right-e">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-2 Layout-epiline-right-f">
            <img src={epiline2} alt="" />
          </div>

          <div className="Layout-epiline-1 Layout-epiline-bottom-a">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-bottom-b">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-bottom-c">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-bottom-d">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-1 Layout-epiline-bottom-e">
            <img src={epiline1} alt="" />
          </div>
          <div className="Layout-epiline-2 Layout-epiline-bottom-f">
            <img src={epiline2} alt="" />
          </div>
        </div>
        <div className="Layout-shapes">
          <div className="Layout-shape-1">
            <img src={shape1} alt="" />
          </div>
          <div className="Layout-shape-2">
            <img src={shape2} alt="" />
          </div>
        </div>
      </div>
    )
  }
}

export default Layout
